var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagen5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "217.000000pt",
    height: "162.000000pt",
    viewBox: "0 0 217.000000 162.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,162.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875 1404 c-82 -30 -270 -98 -417 -150 -146 -53 -280 -105 -297 -115 -26 -16 -31 -25 -31 -58 0 -50 21 -66 150 -111 144 -50 137 -43 97 -98 -69 -94 -89 -154 -107 -317 -14 -129 -32 -182 -101 -290 -40 -63 -49 -105 -27 -122 7 -6 66 -23 131 -39 156 -37 151 -42 155 147 4 145 0 176 -41 296 -20 62 -20 64 -3 120 10 32 27 75 38 96 22 44 85 117 101 117 6 0 130 -43 276 -96 146 -53 284 -99 306 -101 26 -3 66 4 115 20 157 51 836 300 858 313 18 12 22 24 22 64 0 40 -4 52 -22 64 -13 8 -117 48 -233 89 -115 42 -304 109 -419 151 -207 75 -209 76 -305 75 -91 0 -104 -3 -246 -55z m612 -199 c183 -66 333 -122 333 -125 0 -6 -650 -241 -684 -247 -13 -3 -106 24 -212 62 -233 83 -227 80 -189 95 17 7 117 45 223 85 107 40 198 77 204 83 14 14 6 63 -13 75 -13 8 -84 -15 -303 -97 l-287 -108 -64 24 c-36 12 -65 25 -65 28 0 12 667 249 695 247 17 -2 180 -56 362 -122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566 698 c-3 -29 -12 -116 -21 -193 -22 -197 -21 -227 11 -264 14 -17 58 -46 97 -66 220 -108 596 -123 858 -35 89 30 129 53 173 99 39 39 39 40 33 103 -14 164 -40 403 -43 407 -3 3 -32 -4 -67 -15 l-62 -20 -3 -45 c-2 -24 4 -108 13 -187 13 -107 14 -146 6 -156 -16 -20 -98 -53 -178 -73 -52 -13 -112 -17 -258 -17 -207 0 -275 11 -387 61 -68 30 -67 24 -43 218 8 65 15 135 15 155 0 35 -1 37 -62 58 -35 12 -66 22 -70 22 -4 0 -9 -24 -12 -52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagen5);
export default __webpack_public_path__ + "static/media/Imagen5.ea7f26a4b6c39da201f4f73b433fcd11.svg";
export { ForwardRef as ReactComponent };